import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";
import {
  Button,
  Checkbox,
  Container,
  FormControl,
  FormControlLabel,
  Grid,
  Paper,
  TextField,
  Typography,
  Box,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import React, { useEffect, useState } from "react";
import { PlayerProfileService } from "../../../services/playerProfile.Service";

const useStyles2 = makeStyles((theme) => ({
  firstSectionTitle: {
    fontWeight: "500",
    color: "#1d428a",
  },
  label: {
    color: "#8B8B8B",
    wordBreak: "break-all",
  },
  paperStyle: {
    padding: theme.spacing(2),
    marginTop: "15px",
  },
}));

export default function HSEventsAndRankings(props) {
  const {
    eventId,
    playerID,
    styles,
    highSchoolEventsData,
    rankingsData,
    viewProfile,
    setAlert,
    setAlertMessage,
    user,
  } = props;
  const useStyles = makeStyles((theme) => styles);
  const classes = useStyles();
  const classes2 = useStyles2();
  const [highSchoolEvents, setHighSchoolEvents] = useState([]);
  const [rankings, setRankings] = useState([]);
  const [rankingYear, setRankingYear] = useState("");

  useEffect(() => {
    PlayerProfileService.getHighSchoolEventsData().then(
      (highSchoolEventsResponse) => {
        let highSchoolEventsLocalData = [];
        highSchoolEventsResponse.data.forEach((elem) => {
          highSchoolEventsLocalData.push({
            highSchoolEventId: elem.childID,
            highSchoolEventName: elem.childName,
            highSchoolEventCheckBox: false,
            highSchoolEventYear: "",
            mode: "",
          });
        });
        let apiData = [...highSchoolEventsData];
        if (apiData.length) {
          apiData.forEach((item) => {
            highSchoolEventsLocalData.forEach((elem) => {
              if (item.hsEventId === elem.highSchoolEventId) {
                elem.highSchoolEventCheckBox = true;
                elem.highSchoolEventYear = item.eventYear ? item.eventYear : "";
              }
            });
          });
          setHighSchoolEvents(highSchoolEventsLocalData);
        }
        setHighSchoolEvents(highSchoolEventsLocalData);
      }
    );
    PlayerProfileService.getRankingsData().then((rankingsResponse) => {
      let rankingsLocalData = [];
      rankingsResponse.data.forEach((item) => {
        rankingsLocalData.push({
          rankingId: item.childID,
          rankingName: item.childName,
          rankingCheckBox: false,
          rankingNumber: "",
          mode: "",
        });
      });
      let apiData = [...rankingsData];
      let rankYear = 0;
      if (apiData.length) {
        apiData.forEach((item) => {
          rankYear = item.rankYear;
          rankingsLocalData.forEach((elem) => {
            if (item.rankItemId === elem.rankingId) {
              elem.rankingCheckBox = true;
              elem.rankingNumber = item.rankNumber ? item.rankNumber : "";
            }
          });
        });
        setRankingYear(rankYear);
        setRankings(rankingsLocalData);
      }
      setRankings(rankingsLocalData);
    });
  }, [highSchoolEventsData, rankingsData]);

  const handleInputChange = (e, key, id) => {
    let finalValue = e.target.value;
    let newData = [...highSchoolEvents];
    if (key.includes("highSchoolEventYear")) {
      if (e.target.value.length === 1 && e.target.value === "0") {
        e.preventDefault();
      }
      finalValue = e.target.value.replace(/\D/g, "");
    } else if (key.includes("highSchoolEventCheckBox")) {
      finalValue = e.target.checked;
      if (!finalValue) {
        newData[id - 1].highSchoolEventYear = "";
        newData[id - 1].mode = "delete";
        setHighSchoolEvents(newData);
      } else {
        newData[id - 1].mode = "";
      }
    }
    newData[id - 1][key] = finalValue;
    setHighSchoolEvents(newData);
  };

  const handleRankingInputChange = (e, key, id) => {
    let finalValue = e.target.value;
    let newData = [...rankings];
    if (key.includes("rankingNumber") || key === "rankingYear") {
      if (e.target.value.length === 1 && e.target.value === "0") {
        e.preventDefault();
      }
      finalValue = e.target.value.replace(/\D/g, "");
    } else if (key.includes("rankingCheckBox")) {
      finalValue = e.target.checked;
      if (!finalValue) {
        newData[id - 1].rankingNumber = "";
        newData[id - 1].mode = "delete";
        setRankings(newData);
      } else {
        newData[id - 1].mode = "";
      }
    }
    if (key === "rankingYear") {
      setRankingYear(finalValue);
    } else {
      newData[id - 1][key] = finalValue;
      setRankings(newData);
    }
  };

  const submitRecord = () => {
    let formObj = [];
    highSchoolEvents.forEach((elem) => {
      if (elem.highSchoolEventCheckBox || elem.mode === "delete") {
        formObj.push({
          id: 0,
          userBy: user.loginID,
          mode: elem.mode,
          playerID: playerID,
          EventId: `${eventId}`,
          hseventId: parseInt(elem.highSchoolEventId),
          eventName: elem.highSchoolEventName,
          eventYear: elem.highSchoolEventYear
            ? parseInt(elem.highSchoolEventYear)
            : 0,
        });
      }
    });
    PlayerProfileService.insertUpdateHighSchoolEvents(formObj).then(
      (result) => {
        formObj = [];
        rankings.forEach((elem) => {
          if (elem.rankingCheckBox || elem.mode === "delete") {
            formObj.push({
              id: 0,
              userBy: user.loginID,
              mode: elem.mode,
              playerID: playerID,
              EventId: `${eventId}`,
              rankItemId: parseInt(elem.rankingId),
              rankItemName: elem.rankingName,
              rankYear: rankingYear ? parseInt(rankingYear) : 0,
              rankNumber: elem.rankingNumber ? parseInt(elem.rankingNumber) : 0,
            });
          }
        });
        PlayerProfileService.insertUpdateRankings(formObj).then((response) => {
          setAlert(true);
          setAlertMessage("Data updated successfully");
        });
      }
    );
  };

  return (
    <>
      {viewProfile ? (
        <Box mt={3} display={"flex"} flexDirection={"column"}>
          <Typography
            noWrap
            variant={styles.gridSectionTitle.variant}
            className={classes.gridSectionTitle}
          >
            High School Events
          </Typography>
          <Box
            mt={1}
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              flexWrap: "wrap",
            }}
          >
            <Typography
              mb={1}
              noWrap
              variant="subtitle2"
              color="secondary"
              sx={{
                flex: "0 0 50%",
              }}
            >
              Event Name
            </Typography>
            <Typography
              mb={1}
              noWrap
              variant="subtitle2"
              color="secondary"
              sx={{
                flex: "0 0 25%",
              }}
            >
              Year
            </Typography>
            {highSchoolEvents.map((elem, i) => {
              return (
                <React.Fragment key={`hse_${i}`}>
                  <Typography
                    mb={1}
                    component="span"
                    variant="subtitle2"
                    className={classes2.label}
                    sx={{
                      flex: "0 0 50%",
                    }}
                  >
                    {elem.highSchoolEventName}
                  </Typography>
                  <Typography
                    mb={1}
                    component="span"
                    variant="subtitle2"
                    className={classes2.label}
                    sx={{
                      flex: "0 0 25%",
                    }}
                  >
                    {elem.highSchoolEventYear
                      ? elem.highSchoolEventYear
                      : "---"}
                  </Typography>
                </React.Fragment>
              );
            })}
          </Box>
          <Typography
            mt={2}
            noWrap
            variant={styles.gridSectionTitle.variant}
            className={classes.gridSectionTitle}
          >
            Rankings
          </Typography>
          <Box
            mt={1}
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              flexWrap: "wrap",
            }}
          >
            <Typography
              mb={1}
              noWrap
              variant="subtitle2"
              color="secondary"
              sx={{
                flex: "0 0 50%",
              }}
            >
              Year
            </Typography>
            <Typography
              component="span"
              variant="subtitle2"
              className={classes2.label}
              sx={{
                flex: "0 0 25%",
              }}
            >
              {rankingYear ? rankingYear : "---"}
            </Typography>
            <Typography
              mb={1}
              noWrap
              variant="subtitle2"
              color="secondary"
              sx={{
                flex: "0 0 50%",
              }}
            >
              Event Name
            </Typography>
            <Typography
              mb={1}
              noWrap
              variant="subtitle2"
              color="secondary"
              sx={{
                flex: "0 0 35%",
              }}
            >
              Ranking
            </Typography>
            {rankings.map((elem, i) => {
              return (
                <>
                  <Typography
                    mb={1}
                    component="span"
                    variant="subtitle2"
                    className={classes2.label}
                    sx={{
                      flex: "0 0 50%",
                    }}
                  >
                    {elem.rankingName}
                  </Typography>
                  <Typography
                    mb={1}
                    component="span"
                    variant="subtitle2"
                    className={classes2.label}
                    sx={{
                      textAlign: "center",
                      flex: "0 0 35%",
                    }}
                  >
                    {elem.rankingNumber ? elem.rankingNumber : "---"}
                  </Typography>
                </>
              );
            })}
          </Box>
        </Box>
      ) : (
        <Paper elevation={5} className={classes2.paperStyle}>
          <Container maxWidth={false} disableGutters>
            <Grid container>
              <Grid item lg={11} md={11} sm={11} xs={11}>
                <Grid
                  container
                  display="flex"
                  justifyContent={"start"}
                  sx={{
                    padding: "0px 15px 15px 15px",
                  }}
                >
                  <Grid item lg={5} md={6} sm={8} xs={12}>
                    <Grid container spacing={3} pb={2}>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Typography
                          noWrap
                          variant={styles.gridSectionTitle.variant}
                          className={classes.gridSectionTitle}
                        >
                          High School Events
                        </Typography>
                      </Grid>
                    </Grid>
                    <Grid container spacing={3} pb={2}>
                      <Grid item lg={6} md={6} sm={8} xs={8}>
                        <Typography
                          noWrap
                          variant="subtitle2"
                          color="secondary"
                          sx={{
                            textAlign: "right",
                          }}
                        >
                          Event Name
                        </Typography>
                      </Grid>
                      <Grid item lg={4} md={4} sm={4} xs={4}>
                        <Typography
                          noWrap
                          variant="subtitle2"
                          color="secondary"
                          sx={{
                            textAlign: "left",
                          }}
                        >
                          Year
                        </Typography>
                      </Grid>

                      {highSchoolEvents.map((elem, i) => {
                        return (
                          <Grid item sm={12} key={i}>
                            <Grid container spacing={3}>
                              <Grid item lg={6} md={6} sm={8} xs={8}>
                                <FormControl
                                  size="small"
                                  fullWidth
                                  margin="dense"
                                >
                                  <FormControlLabel
                                    value="start"
                                    control={
                                      <Checkbox
                                        size="medium"
                                        color="success"
                                        checked={elem.highSchoolEventCheckBox}
                                        onChange={(e) =>
                                          handleInputChange(
                                            e,
                                            "highSchoolEventCheckBox",
                                            elem.highSchoolEventId
                                          )
                                        }
                                        sx={{ alignSelf: "flex-start" }}
                                      />
                                    }
                                    label={
                                      <Typography variant="subtitle2">
                                        {elem.highSchoolEventName}
                                      </Typography>
                                    }
                                    labelPlacement="start"
                                    className={classes2.label}
                                  />
                                </FormControl>
                              </Grid>
                              <Grid item lg={3} md={3} sm={4} xs={4}>
                                <FormControl size="small" margin="dense">
                                  <TextField
                                    size="small"
                                    value={elem.highSchoolEventYear}
                                    disabled={!elem.highSchoolEventCheckBox}
                                    onChange={(e) =>
                                      handleInputChange(
                                        e,
                                        "highSchoolEventYear",
                                        elem.highSchoolEventId
                                      )
                                    }
                                  />
                                </FormControl>
                              </Grid>
                            </Grid>
                          </Grid>
                        );
                      })}
                    </Grid>
                  </Grid>

                  {/* Rankings */}

                  <Grid item lg={5} md={6} sm={8} xs={12}>
                    <Grid container spacing={3} pb={2}>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Typography
                          noWrap
                          variant={styles.gridSectionTitle.variant}
                          className={classes.gridSectionTitle}
                        >
                          Rankings
                        </Typography>
                      </Grid>
                    </Grid>
                    <Grid container spacing={3} pb={2}>
                      <Grid
                        item
                        lg={4}
                        md={4}
                        sm={8}
                        xs={8}
                        sx={{
                          alignSelf: "center",
                          textAlign: "right",
                        }}
                      >
                        <Typography
                          noWrap
                          variant="subtitle2"
                          component="span"
                          color="secondary"
                        >
                          Year
                        </Typography>
                      </Grid>
                      <Grid item lg={3} md={4} sm={4} xs={4}>
                        <TextField
                          size="small"
                          value={rankingYear}
                          onChange={(e) =>
                            handleRankingInputChange(e, "rankingYear", 0)
                          }
                        />
                      </Grid>
                    </Grid>
                    <Grid container spacing={3} pb={2}>
                      <Grid item lg={4} md={4} sm={8} xs={8}>
                        <Typography
                          noWrap
                          variant="subtitle2"
                          color="secondary"
                          sx={{
                            textAlign: "right",
                          }}
                        >
                          Event Name
                        </Typography>
                      </Grid>
                      <Grid item lg={4} md={4} sm={4} xs={4}>
                        <Typography
                          noWrap
                          variant="subtitle2"
                          color="secondary"
                          sx={{
                            textAlign: "left",
                          }}
                        >
                          Ranking
                        </Typography>
                      </Grid>
                    </Grid>
                    {rankings.map((elem, i) => {
                      return (
                        <Grid item sm={12} key={i}>
                          <Grid container spacing={3}>
                            <Grid item lg={4} md={4} sm={8} xs={8}>
                              <FormControl
                                size="small"
                                fullWidth
                                margin="dense"
                              >
                                <FormControlLabel
                                  value="start"
                                  control={
                                    <Checkbox
                                      size="medium"
                                      color="success"
                                      checked={elem.rankingCheckBox}
                                      onChange={(e) =>
                                        handleRankingInputChange(
                                          e,
                                          "rankingCheckBox",
                                          elem.rankingId
                                        )
                                      }
                                      sx={{ alignSelf: "flex-start" }}
                                    />
                                  }
                                  label={
                                    <Typography variant="subtitle2">
                                      {elem.rankingName}
                                    </Typography>
                                  }
                                  labelPlacement="start"
                                  className={classes2.label}
                                />
                              </FormControl>
                            </Grid>
                            <Grid item lg={2} md={3} sm={3} xs={3}>
                              <FormControl
                                size="small"
                                fullWidth
                                margin="dense"
                              >
                                <TextField
                                  size="small"
                                  value={elem.rankingNumber}
                                  disabled={!elem.rankingCheckBox}
                                  onChange={(e) =>
                                    handleRankingInputChange(
                                      e,
                                      "rankingNumber",
                                      elem.rankingId
                                    )
                                  }
                                />
                              </FormControl>
                            </Grid>
                          </Grid>
                        </Grid>
                      );
                    })}
                  </Grid>
                </Grid>
              </Grid>
              <Grid
                item
                lg={1}
                md={1}
                sm={1}
                xs={1}
                sx={{ textAlign: "right" }}
              >
                <Button
                  className={classes.saveButton}
                  size={classes.submitButtonSize}
                  variant={styles.saveButton.variant}
                  title={styles.saveButton.title}
                  onClick={() => submitRecord("update")}
                >
                  <SaveOutlinedIcon />
                </Button>
              </Grid>
            </Grid>
          </Container>
        </Paper>
      )}
    </>
  );
}
